module.exports = __webpack_public_path__ + "img/dlt.168b2059.jpg";